import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import styles from "./LandingBlogTeaser.module.css";
import BlogCard from "../../blog/BlogCard";
import useBlogPosts from "../../blog/useBlogPosts";
import { Stagger, StaggerItem } from "../../../../components/motion";

const TEASER_LIMIT = 2;

/**
 * Últimos artículos del blog en el home. Si no hay artículos (o el API falla)
 * la sección no se muestra.
 * @param {object} props
 * @param {object} [props.reveal]
 * @param {function} [props.sectionReveal]
 */
const LandingBlogTeaser = ({ reveal, sectionReveal }) => {
  const { posts, loading } = useBlogPosts({ limit: TEASER_LIMIT });
  const latest = posts.slice(0, TEASER_LIMIT);
  const hidden = loading || latest.length === 0;

  const sectionClass =
    sectionReveal && reveal ? `${styles.section} ${sectionReveal(reveal)}` : styles.section;

  return (
    <section
      ref={reveal?.ref}
      className={sectionClass}
      id="blog"
      aria-labelledby="landing-blog-title"
      hidden={hidden}
    >
      <div className={styles.inner}>
        <div className={styles.head}>
          <div>
            <p className={styles.eyebrow}>Blog Gold</p>
            <h2 id="landing-blog-title" className={styles.title}>
              Lo último en nuestro blog
            </h2>
          </div>
          <Link to="/blog" className={styles.allLink}>
            Ver todos los artículos
            <FontAwesomeIcon icon={faArrowRight} />
          </Link>
        </div>
        <Stagger className={styles.grid}>
          {latest.map((post) => (
            <StaggerItem key={post.slug} className="motion-fill">
              <BlogCard post={post} headingLevel="h3" />
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
};

export default LandingBlogTeaser;
